// src/components/Legal/Commitments.js

import React from "react";
import "../../styles/ijrr.css";

export default function Commitments() {
  return (
    <section className="space-pb-80">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="original-title text-center golden mb-4">
              Commitments of the Pyrate’s Code
            </h2>

            <p className="ijrr-text">
              The International Jolly Roger Registry (IJRR) is more than a membership. It is a community, a family, and a global club of individuals who share a desire to live with intention, identity, and creative freedom. Inspired by the historical Articles of Agreement, our modern interpretation of the Pyrate’s Code is built on values that guide how we treat each other and the world around us.
            </p>

            <p className="ijrr-text">
              By raising your flag as a member of the IJRR, you are not only expressing your individuality, but also embracing a set of shared commitments that unite us across borders, backgrounds, and beliefs. These commitments define the spirit of our Registry and shape the future of our growing society.
            </p>

            <br />

            <div className="ijrr-text">
              <p className="commitment-block">
                <strong>Respect for Individual Identity:</strong><br />
                Each member has the freedom to express who they are. We celebrate diversity in thought, culture, image, and voice. Your story matters, and your flag represents it.
              </p>

              <p className="commitment-block">
                <strong>Zero Tolerance for Discrimination:</strong><br />
                Every member, regardless of origin, identity, or orientation, is welcome aboard. There is no room for hate in our club. Only mutual respect and equality.
              </p>

              <p className="commitment-block">
                <strong>Loyalty to the Club:</strong><br />
                As part of the IJRR, we uplift and encourage each other. Whether online or in person, we support one another in the pursuit of creativity, freedom, and meaningful connection.
              </p>

              <p className="commitment-block">
                <strong>Consent and Integrity:</strong><br />
                Just as no pirate boards another’s ship without permission, we honor boundaries. No image, idea, or identity should be used without clear consent.
              </p>

              <p className="commitment-block">
                <strong>Fair Conduct and Trade:</strong><br />
                Our platform promotes honest exchange, creative collaboration, and ethical commerce. Every deal and interaction should be marked by transparency and respect.
              </p>

              <p className="commitment-block">
                <strong>Spirit of Adventure and Legacy:</strong><br />
                We are here to build something that lasts. As members of the IJRR, we carry forward the legacy of those who dared to be different and keep that flame alive for future generations.
              </p>
            </div>

            <br />

            <p className="ijrr-text">
              These commitments are not strict rules. They are guiding values. They represent the heart of the International Jolly Roger Registry — a club for free thinkers, bold creatives, and kindred spirits who believe in something real, something noble, and something worth sharing. When you fly your flag, you show the world that you belong to a community with purpose, dignity, and pride.
            </p>

            <br />

            <p className="ijrr-text text-center">
              Welcome aboard. We are honored to sail with you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}